const menuItems = [
  {
    path: "/",
    name: "Home",
  },
];

export default menuItems;
